import { FC, memo } from 'react'
import { Flex, Text } from '@chakra-ui/react'

import { Citizen, CitizenFilter } from 'CitizenProfile/types'
import { capitalizeString } from 'utils/transforms/string'
import { Highlight } from 'components'

type CitizenFamilyFields = {
  motherName: boolean
  fatherName: boolean
}

type Props = {
  citizenFilter?: CitizenFilter
  citizen: Citizen
  citizenFamilyFields: CitizenFamilyFields
}

const CitizenCardFamily: FC<Props> = ({ citizenFilter, citizen, citizenFamilyFields }) => {
  return (
    <Flex width="100%" direction="column" gap={2}>
      {(citizenFamilyFields.motherName || citizenFamilyFields.fatherName) && <Text variant="secondary">Família</Text>}
      <Flex direction="column" gap={0}>
        {citizenFamilyFields.motherName && (
          <Text variant="secondary" as="span">
            Mãe:{' '}
            <Text color="dark" as="span">
              <Highlight query={citizenFilter?.mother_name as string}>{capitalizeString(citizen.mother_name)}</Highlight>
            </Text>
          </Text>
        )}
        {citizenFamilyFields.fatherName && (
          <Text variant="secondary" as="span">
            Pai:{' '}
            <Text color="dark" as="span">
              <Highlight query={citizenFilter?.father_name as string}>{capitalizeString(citizen.father_name)}</Highlight>
            </Text>
          </Text>
        )}
      </Flex>
    </Flex>
  )
}

export default memo(CitizenCardFamily)
